import { isPast } from 'date-fns';
import { useEffect, useState } from 'react';
import { interval, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { convertMilliseconds } from '@swf/core/utils';
import { TIME } from '@swf/poker';

import { getSafeMilliseconds } from '../../utils/getSafeMilliseconds';

const useCountdown = (
  targetDateInSeconds: string | number | undefined = '',
  intervalMs: number = TIME.SECOND
): { days: number; hours: number; minutes: number; seconds: number } => {
  const timeInMilliseconds = getSafeMilliseconds(targetDateInSeconds);
  const date = isPast(timeInMilliseconds) ? Date.now() : timeInMilliseconds;
  const [countDown, setCountDown] = useState(date - Date.now());

  useEffect(() => {
    const diff = date - Date.now();
    const source = interval(intervalMs);
    const subscription = source
      .pipe(takeUntil(timer(diff)))
      .subscribe(() => setCountDown(date - Date.now()));

    return () => subscription.unsubscribe();
  }, [date, intervalMs]);

  return convertMilliseconds(countDown);
};

export default useCountdown;
